import { MRT_ColumnDef, useMaterialReactTable, MaterialReactTable } from 'material-react-table'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'
import React, { useMemo } from 'react'
import { bgLineGridColorDark, bgLineGridColorLight, contaAPagar, ContaAReceber, corBgGrid } from '../../Utils/Types'
import { createTheme, ThemeProvider } from '@mui/material'
import { useSelector } from 'react-redux'
import { selectUser } from '../Redux/userSlice'
import { Funcoes } from '../../Utils/Funcoes'
import moment from 'moment'

type Props = {
    duplicatas: ContaAReceber[],
}

interface RowData {
    id: number,
    dh_cancel: string,
    name_user_cancel: number,
    motivo_cancel: string,
    nome_cliente: string,
    serie: string,
    valor: number,
    valor_original: number,

}

export const GridContaAreceberExcluidas = React.memo(({ duplicatas }: Props) => {

    let user = useSelector(state => selectUser(state))

    const theme = createTheme({
        palette: {
            mode: user.modeDark,
            background: {
                default:
                    user.modeDark === 'light' ? '#fff' : '#475569', 
            },
        },
    })

    const baseBackgroundColor = user.modeDark === 'dark' ? '#475569' : '#fff'

    const colunas = useMemo<MRT_ColumnDef<ContaAReceber>[]>(
        () => [

            {
                accessorKey: 'nome_cliente', header: 'Cliente', size: 300, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return ( rowData.nome_cliente ? rowData.nome_cliente : <span className='text-red-400'>N/D</span>)
                }
            },
            {
                accessorKey: 'serie', header: 'Série', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return ( rowData.serie ? rowData.serie : <span className='text-red-400'>N/D</span>)
                }
            },
            {
                accessorKey: 'valor', header: 'Valor (R$)', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return ( rowData.valor ? Funcoes.numberFormat(rowData.valor, 'currency') : <span className='text-red-400'>N/D</span>)

                }
            },
            {
                accessorKey: 'valor_original', header: 'Valor Original', size: 20, muiTableBodyCellProps: { align: 'center' }, muiTableHeadCellProps: { align: 'center' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return ( rowData.valor_original ? Funcoes.numberFormat(rowData.valor_original, 'currency') : <span className='text-red-400'>N/D</span>)

                }
            },
            {
                accessorKey: 'name_user_cancel', header: 'Usuário de Exclusão', size: 50, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return ( rowData.name_user_cancel ? rowData.name_user_cancel : <span className='text-red-400'>N/D</span>)

                }
            },
            {
                accessorKey: 'motivo_cancel', header: 'Motivo de Exclusão', size: 50, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return ( rowData.motivo_cancel ? rowData.motivo_cancel : <span className='text-red-400'>N/D</span>)

                }
            },
            {
                accessorKey: 'dh_cancel', header: 'Data de Exclusão', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return ( rowData.dh_cancel ? moment(rowData.dh_cancel).format('DD/MM/YYYY') : <span className='text-red-400'>N/D</span>)

                }
            },

        ], []
    )

    const table = useMaterialReactTable({
        columns: colunas,
        data: duplicatas,
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,

        }),
        muiTableHeadCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`,
                backgroundColor: corBgGrid,
                color: `#fff`,
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': {
                        color: '#fff !important',
                    },
                    '&.Mui-active': {
                        color: '#fff !important',
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                },
                '& .MuiIconButton-root': {
                    color: '#fff',
                    '&:hover': {
                        color: '#fff',
                    },
                },
            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`
            }
        },
        enableEditing: false,
        enableTopToolbar: false,
        enableColumnFilters: false,
        enableHiding: false,
        enableFilters: false,
        enableMultiSort: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        localization: MRT_Localization_PT_BR,
        paginationDisplayMode: 'pages',
    })

    return (
        <>
            <ThemeProvider theme={theme}>

                <MaterialReactTable table={table} />

            </ThemeProvider>

        </>
    )
})